import { useIntl } from "react-intl";

import { ConfirmDrawer } from "@/components/ConfirmDrawer/ConfirmDrawer";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function TravellerCloseConfirmDrawer({
  open,
  onClose,
  onConfirm,
}: Props) {
  const intl = useIntl();

  return (
    <ConfirmDrawer
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={intl.formatMessage({
        id: "travellers.closeConfirmation.title",
        defaultMessage: "Are you sure you want to leave?",
      })}
      description={intl.formatMessage({
        id: "travellers.closeConfirmation.description",
        defaultMessage: "Any unsaved data will be lost",
      })}
      closeLabel={intl.formatMessage({ id: "back", defaultMessage: "Back" })}
      confirmLabel={intl.formatMessage({
        id: "travellers.closeConfirmation.leave",
        defaultMessage: "Leave without saving",
      })}
    />
  );
}
